export const domainText = [
  {
    header: "What is a primary domain?",
    subHeader:
      "The primary domain is the main address where your website traffic will be directed. Once you set the primary domain, update it in the WordPress admin panel and run a search and replace to ensure consistency across your site.",
    readMore: "https://docs.roconpaas.io/",
  },
  // {
  //   header: "What is www domain?",
  //   subHeader:
  //     "A www domain is an alternate version of your primary domain that includes the www prefix (e.g., www.example.com). After setting the primary domain, you must update it in the WordPress admin panel and perform a search and replace to ensure all URLs reflect the correct domain format.",
  //   readMore: "https://docs.roconpaas.io/",
  // },
  {
    header: "What are wildcard ssl certificates?",
    subHeader:
      "A wildcard SSL certificate secures a primary domain and its subdomains under a single certificate. After configuring the primary domain, update it in the WordPress admin panel and perform a search and replace to apply the changes across your site.",
    readMore: "https://docs.roconpaas.io/",
  },
];
